import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Pill from "../../../common/Pill";
import styles from "./status.module.scss";

export function WaitingInspectionStatus() {
  const { t } = useTranslation();

  return (
    <Pill
      styleName="waitingDelivery"
      Lefticon={<img src={"../../../assets/images/svg/inspection.svg"} />}>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_contract_list_items_wating_for_inspection")}
      </p>
    </Pill>
  );
}
